/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import moment from 'moment';

// serialized DateTime -> JS Date
function dateMapper(dateString, adjustForTimezone = false) {
  if (!dateString || moment(dateString).year() === 0) return null;
  // Json.NET serialzes as: 2015-10-19T22:38:54.0595191Z

  if (adjustForTimezone) {
    // if server actually gives us accurate time, we should localize it
    return moment(dateString).toDate();
  }

  // server DateTime mappings have always given us incorrect datetime string values for date only types
  // Example:
  // date comes back like '2025-01-01T00:00:00Z'
  // which officially represents Jan 1, 2025 at midnight in Zulu Time
  // The Zulu timezone would indicate that the local Eastern time should be -4 or -5 hours so it would
  // always be interpreted as the previous day at 7pm or 8pm
  // To get around this, we need to parse the string WITHOUT the Zulu indicator to correct the server's bad representation
  return moment(dateString, 'YYYY-MM-DDThh:mm:ss').toDate();
}

export default dateMapper;